import { useContext, useState } from "react";
import { ThemeContext } from "../../context";
import "./contact.scss";
import emailjs from "@emailjs/browser";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export default function Contact() {
    const theme = useContext(ThemeContext)
    const darkMode = theme.state.darkMode
    const [name,setName] = useState("");
    const [email,setEmail] = useState("");
    const [message,setMessage] = useState("");
    const [loader, setLoader] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoader(true);
        try {
            if (!executeRecaptcha) {
                alert("reCAPTCHA not yet available. Please try again later.");
                setLoader(false);
                return;
            }
            const token = await executeRecaptcha('contact_form');
            await emailjs.send(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                { from_name: name, from_email: email, message: message, "g-recaptcha-response": token },
                process.env.REACT_APP_EMAILJS_PUBLIC_KEY
            );
            alert("Thank you for your message! I will try and respond as soon as I am able.");
            setName("");
            setEmail("");
            setMessage("");
        } catch (err) {
            alert("There was an error sending your message. Please try again later.");
        }
        setLoader(false);
    };
    return (
        <div className="contact" id="contact">
            <div className="left">
                <img src="assets/contact.png" alt="" />
            </div>
            <div className="right">
                <h2>Contact</h2>
                <form onSubmit={handleSubmit}>
                    <input style={{backgroundColor: darkMode && "#555", color: darkMode && "white"}} type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)}/>
                    <input style={{backgroundColor: darkMode && "#555", color: darkMode && "white"}} type="text" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                    <textarea style={{backgroundColor: darkMode && "#555", color: darkMode && "white"}} placeholder="Message" value={message} onChange={(e) => setMessage(e.target.value)}></textarea>
                    <button type="submit" style={{background: loader ? "gray" : "green"}}>Send</button>
                </form>
            </div>            
        </div>
    )
}
